import React from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import { Row, Col } from 'antd';
import { GUTTER_XS,SPAN_TWO_QUARTERS } from '../../../../../../../styles/constants';
import {connect} from 'react-redux';
import _ from "lodash";
import FormList from '../../../../../../../components/form-list';
import { getInitIffCondition } from '../../../utils';
import IffCondition from './IffCondition';
import SelectEditable from '../SelectEditable';
import { onChangeIfFunction } from '../../actions';



const mapStateToProps = state => ({
    IfFormDataList: state.scenes.dataManager.fileMapping.components.wizard.components.addField.IfFormDataList,
    nameValue:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData.nameValue
});

const mapDispatchToProps = dispatch => ({
  onChangeForm: value => dispatch(onChangeIfFunction(value)),
})


const IffBlock= ({
                      t,
                      IfFormDataList,
                      value,
                      selectFunction,
                      selectComponent,
                      onChangeForm,
                      selectOperators,
                      nameValue
                    }) => {

const block = React.useMemo(()=> { return value},[value])
const conditionIndex = (value.conditions || []).length
const dataList = React.useMemo(()=> {return IfFormDataList},[IfFormDataList])

const [componentY, setComponentY] = React.useState(null)
const [componentZ, setComponentZ] = React.useState(null)

React.useEffect(()=>{
  if(_.some(block.componentY)){
      setComponentY(block.componentY)
  }else{
      setComponentY(null)
  }
},[block])

React.useEffect(()=>{
  if(_.some(block.componentZ)){
      setComponentZ(block.componentZ)
  }else{
      setComponentZ(null)
  }
},[block])


const handleChangeComponentZ = (value) => {
  if(dataList.length > 1){
      setComponentZ(dataList.length > 1 ? value: '')
      onChangeForm({blockIdx:block.blockIdx - 1, componentZ: ''})
      onChangeForm({blockIdx:block.blockIdx, componentZ: value })
  }else{
      setComponentZ(value)
      onChangeForm({blockIdx:block.blockIdx, componentZ: value })
  }
}


const handleChangeComponentY = (value) => {
      setComponentY(value)
      onChangeForm({blockIdx:block.blockIdx, componentY: value })
}

return (<React.Fragment>
  <Col style={{textAlign:'center'}}>
      <span>X</span>
        <FormList 
          notCollapsable
          compact
          values={block.conditions}
          Component={IffCondition}
          newItem={getInitIffCondition(conditionIndex)}
          componentProps={{
            selectFunction,
            selectComponent,
            onChangeForm,
            selectOperators,
            block:block
          }}
          onChange={(values) => onChangeForm({blockIdx: block.blockIdx, conditions: values })}
          addItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.addCondition')}
          removeItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.removeCondition')}
        />
    </Col>
        <Row type="flex" style={{ alignItems:'center', marginTop:10}}>
          <Col span={SPAN_TWO_QUARTERS}>
                <Row type="flex" style={{alignItems:'flex-end',gap:10, }}>
                    <Col style={{marginBottom:GUTTER_XS}}>
                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.iif.label.ifXIsTrue')}</span>                           
                    </Col>
                    <Col>                           
                        <Row type="flex" style={{alignItems:'flex-end',gap:10, }}>
                            <span style={{marginBottom:GUTTER_XS, textTransform:'uppercase'}}>
                                {!!nameValue ? `${nameValue}=` : t('scenes.dataManager.fileMapping.wizard.addField.label.baseFor')}</span>                   
                            <div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
                            <span style={{textAlign:'center'}}>Y</span>  
                                        <SelectEditable 
                                            width={150}
                                            value={componentY}
                                            options={selectComponent}
                                            onValue={(value) => handleChangeComponentY(value)}
                                        /> 
                            </div>                 
                        </Row>
                    </Col>   
                </Row>
          </Col>
          <Col span={SPAN_TWO_QUARTERS}>
                <Row type="flex" style={{alignItems:'flex-end',gap:10, }}>
              <Col style={{marginBottom:GUTTER_XS}}>
              <span>{t('scenes.dataManager.fileMapping.wizard.addField.label.else')}</span>
              </Col>
              <Col >
              <Row type="flex" style={{alignItems:'flex-end',gap:10}}>
                  <span style={{marginBottom:GUTTER_XS, textTransform:'uppercase'}}>
                  {!!nameValue ? `${nameValue}=`: t('scenes.dataManager.fileMapping.wizard.addField.label.baseFor')}
                  </span>     
                  <div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
                  <span style={{textAlign:'center'}}>Z</span>  
                          <SelectEditable 
                              disabled={dataList.length - 1 !== block.blockIdx}
                              width={150}
                              value={ dataList.length -1 === block.blockIdx ? componentZ : ''}
                              options={selectComponent}
                              onValue={(value) => handleChangeComponentZ(value)}
                          /> 
                  </div>
              </Row>
              </Col>
                </Row>
          </Col>
        </Row>   
  </React.Fragment> 
);
}


export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(IffBlock);
